import styled from 'styled-components';
import c from '../../utils/constants';

export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 0.5em;
`;
export const P = styled.p`
  color: ${c.primary};
  font-size: 1em;
  padding: 0.1em;
  text-align: justify
`;
